import React from "react";
import { MDBIcon } from "mdbreact";
import styles from "./index.module.css";

export class PasswordInput extends React.Component {
  state = {
    isPasswordVisible: false
  };

  render() {
    const { isPasswordVisible } = this.state;
    return (
      <div className={styles.input}>
        <input type={isPasswordVisible ? "text" : "password"} {...this.props} />
        <button
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            this.setState({ isPasswordVisible: !isPasswordVisible });
          }}
          className={styles.button}
        >
          <MDBIcon icon={isPasswordVisible ? "eye" : "eye-slash"} />
        </button>
      </div>
    );
  }
}
